
import Vue from "vue";
import store from '../store';
import { IGuidelineItem } from "@/shared/models/guidelineitem.model";
import { Colors } from "@/shared/models/condition.model";
import ConditionItem from '../components/ConditionItem.vue'
import GuidelineHeading from './GuidelineHeading.vue'
import { ResponsibilityType } from "@/shared/enums/responsibilitytype.enum";

export default Vue.extend({
    name: "GuidelineItem",
    components: {
        ConditionItem,
        GuidelineHeading
    },

    props: {
        item: Object as () => IGuidelineItem,
        level: Number
    },
    data() {
        return {
            hasGreenCondition: false as boolean,
            hasYellowCondition: false as boolean,
            isSameCondition: false as boolean,
            isOnlyGreenCondition: false as boolean,
            isOnlyYellowCondition: false as boolean,
            isTwoConditions: false as boolean,
            singleColor: Colors.Mixed as string,
            green: Colors.Green,
            yellow: Colors.Yellow,
            isReady: false as boolean,
            dialog: false
        };
    },
    mounted() {
        this.setConditionValues();
        this.isReady = true;
    },
    watch: {

    },
    methods: {
        isAdmin(): boolean {
            return store.state.isTdAdmin;
        },
        setConditionValues() {
            if (this.item.Extended.Condition) {
                this.hasGreenCondition = this.item.Extended.Condition.trim().length > 0;
            }
            if (this.item.Normal.Condition) {
                this.hasYellowCondition = this.item.Normal.Condition.trim().length > 0;
            }
            this.isSameCondition = this.item.Normal.Condition === this.item.Extended.Condition && this.item.Normal.Reference === this.item.Extended.Reference;
            this.isOnlyGreenCondition = this.hasGreenCondition && !this.hasYellowCondition;
            this.isOnlyYellowCondition = !this.hasGreenCondition && this.hasYellowCondition;
            this.isTwoConditions = this.hasGreenCondition && this.hasYellowCondition && !this.isSameCondition;
            if (this.isOnlyGreenCondition) {
                this.singleColor = Colors.Green;
            }
            else if (this.isOnlyYellowCondition) {
                this.singleColor = Colors.Yellow;
            }
            else {
                this.singleColor = Colors.Mixed;
            }
        },
        getTdUrl(): string {
            return `https://td4.vgregion.se/sv/InventoryObjects/InventoryObject/${this.item.InventoryObjectId}#${this.item.Id}`;
        },
        filter(): boolean {
           return store.state.filter.includes(this.item.Responsibility as ResponsibilityType)
        }
    },

});
